import { useState, useEffect, useRef } from "react";
import CustomToastContainer from "../../Common/CustomToastContainer";

const domainpath = process.env.REACT_APP_API_DOMAIN_ENDPOINT;

const AcceptBid = ({ selectedNFT, userId }) => {
  const [loading, setLoading] = useState(false);
  const toastRef = useRef();
  if (!selectedNFT || !selectedNFT.currentBid || !selectedNFT.currentBidder) {
    return (
      <section className="breadcumb no-bg">
        <div className="mainbreadcumb container">
          <p className="text-center">No active bids available for this NFT.</p>
        </div>
      </section>
    );
  }

  const handleAcceptOffer = async () => {
    if (selectedNFT.owner !== userId) {
      toastRef.current.addToast("You are not the owner of this NFT.", "error");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(
        `${domainpath}/api/bid/accept-bid/${selectedNFT._id}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ ownerId: userId }),
        }
      );

      const data = await response.json();
      if (data.success) {
        toastRef.current.addToast(
          "Offer accepted! Ownership transferred.",
          "success"
        );
      } else {
        toastRef.current.addToast(data.message, "error.");
      }
    } catch (error) {
      console.error("Error accepting bid:", error);
      toastRef.current.addToast("Something went wrong. Try again.", "error");
    }

    setLoading(false);
  };

  return (
    <>
      <section className="breadcumb no-bg">
        <div className="mainbreadcumb">
          <div className="border p-4 rounded-lg">
            <h3>Highest Offer</h3>
            <p>Amount: {selectedNFT.currentBid} ETH</p>
            <p>Bidder: {selectedNFT.currentBidder}</p>
            <button
              onClick={handleAcceptOffer}
              disabled={loading}
              className="bg-blue-500 text-white px-4 py-2 rounded-lg"
            >
              {loading ? "Processing..." : "Accept Offer"}
            </button>
          </div>
        </div>
      </section>
      <CustomToastContainer ref={toastRef} />
    </>
  );
};

export default AcceptBid;
